import React from 'react';

const Image = ({ align, alt, src, children }) => {
  let classes = 'plant-image';
  if (align) {
    classes += ` align-${align}`;
  }
  const imageSrc = src?.startsWith('https://') ? src : `../../images/${src}`;

  return (
    <figure className={classes}>
      <img src={imageSrc} alt={alt} />
      {children && <figcaption>{children}</figcaption>}
    </figure>
  );
};

export default Image;
